<template>
    <div id="criteria">
        <h2>Criteria</h2>
        <div class="criteria-group" v-for="crit in criteriaGroups" v-bind:key="crit.idCriteria">
            <span class="criteria-title">{{crit.criteriaTitle}}</span>
            <ul v-show="crit.options.length > 0">
                <li v-for="option in crit.options" v-bind:key="option.idCriteriaOption">
                    <span class="option-title">{{option.optionTitle}}</span>
                    <span class="option-description text-muted" v-show="option.optionDescription">{{option.optionDescription}}</span>
                </li>
            </ul>
            <div v-if="crit.note" class="criteria-note">{{crit.note}}</div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: "Criteria",
        props: ['criteria'],
        computed: {
            criteriaGroups (){
                let cg = [];
                let groups = _.groupBy(this.criteria, 'idCriteria');

                Object.keys(groups).forEach(idCriteria => {
                    let currCrit = groups[idCriteria];
                    let thisCrit = {idCriteria: idCriteria};

                    thisCrit.criteriaTitle = currCrit[0].criteriaTitle;
                    thisCrit.criteriaDescription = currCrit[0].criteriaDescription;
                    thisCrit.note = currCrit[0].note;

                    if(currCrit[0].idCriteriaOption == null) {
                        thisCrit.options = [];
                    } else {
                        thisCrit.options = currCrit;
                    }

                    cg.push(thisCrit);
                });

                return cg;
            }
        }
    }
</script>

<style scoped>

</style>